<div class="municipality-container">
    <div><label class="labelTitle" for="municipality">{{ 'PREVIEW_SPACE.COMMUNITY_SELECT' | translate }}</label></div>
    <div><app-cpm [comunidad]=true></app-cpm></div>
</div>